import { DEFAULT_LANGUAGE_CODE, LANGUAGE_CODES, LanguageCode } from '@/constants/languages';
import { initializeI18n } from '@/lib/i18next-config';
import { useLanguageStore } from '@/stores/language-store';
import { useFonts } from 'expo-font';
import * as Localization from 'expo-localization';
import { useEffect, useState } from 'react';

export function RootInitializer({ children }: React.PropsWithChildren) {
  const { setLocale } = useLanguageStore();
  const [ready, setReady] = useState(false);
  const [loaded, error] = useFonts({
    'Lexend-Thin': require('../assets/fonts/Lexend-Thin.ttf'),
    'Lexend-ExtraLight': require('../assets/fonts/Lexend-ExtraLight.ttf'),
    'Lexend-Light': require('../assets/fonts/Lexend-Light.ttf'),
    Lexend: require('../assets/fonts/Lexend-Regular.ttf'),
    'Lexend-Regular': require('../assets/fonts/Lexend-Regular.ttf'),
    'Lexend-Medium': require('../assets/fonts/Lexend-Medium.ttf'),
    'Lexend-SemiBold': require('../assets/fonts/Lexend-SemiBold.ttf'),
    'Lexend-Bold': require('../assets/fonts/Lexend-Bold.ttf'),
    'Lexend-ExtraBold': require('../assets/fonts/Lexend-ExtraBold.ttf'),
    'Lexend-Black': require('../assets/fonts/Lexend-Black.ttf'),
  });

  useEffect(() => {
    if (error) throw error;
  }, [error]);

  useEffect(() => {
    initializeI18n().finally(() => setReady(true));
    const deviceLang = Localization.getLocales()?.[0]?.languageCode ?? DEFAULT_LANGUAGE_CODE;
    const initialLocale = LANGUAGE_CODES.includes(deviceLang as any) ? deviceLang : DEFAULT_LANGUAGE_CODE;
    setLocale(initialLocale as LanguageCode);
  }, []);

  if (!loaded && !error) {
    return null;
  }

  if (!ready) return null;

  return <>{children}</>;
}
